import { memo } from 'react';
import { Box, Text } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../constants';
import PlusIndicatorIcon from '../icons/assets/PlusIndicatorIcon';

export interface AddIndicatorButtonProperties {
  onClick: () => void;
}

const AddIndicatorButton = memo(({ onClick }: AddIndicatorButtonProperties) => (
  <Box
    as='button'
    type='button'
    onClick={onClick}
    aria-label='Add new indicator'
    display='inline-flex'
    alignItems='center'
    justifyContent='center'
    gap='8px'
    w={{ base: '100%', sm: BUILDER_MODE_V1_LAYOUT.addIndicatorButtonWidth }}
    minW={{ base: 'auto', sm: BUILDER_MODE_V1_LAYOUT.addIndicatorButtonWidth }}
    maxW='100%'
    h={BUILDER_MODE_V1_LAYOUT.addIndicatorButtonHeight}
    minH={BUILDER_MODE_V1_LAYOUT.addIndicatorButtonHeight}
    px={BUILDER_MODE_V1_LAYOUT.addIndicatorButtonPaddingX}
    py={BUILDER_MODE_V1_LAYOUT.addIndicatorButtonPaddingY}
    bg={BUILDER_MODE_V1_TOKENS.white}
    border='1px solid'
    borderColor={BUILDER_MODE_V1_TOKENS.border}
    borderRadius={BUILDER_MODE_V1_LAYOUT.actionButtonRadius}
    cursor='pointer'
    flexShrink={0}
    boxSizing='border-box'
    _hover={{ bg: BUILDER_MODE_V1_TOKENS.activeBg }}
    _active={{ bg: BUILDER_MODE_V1_TOKENS.activeBg }}
  >
    <PlusIndicatorIcon />
    <Text
      flex='1'
      minW={0}
      fontSize='14px'
      fontWeight='500'
      color={BUILDER_MODE_V1_TOKENS.textDark}
      lineHeight='normal'
      textAlign='center'
      noOfLines={1}
    >
      Add New Indicator
    </Text>
  </Box>
));

AddIndicatorButton.displayName = 'AddIndicatorButton';

export default AddIndicatorButton;
